export const sessionNames = [
  { value: 'Resume Review', label: 'Resume Review' },
  { value: 'LinkedIn Profile Optimisation', label: 'LinkedIn Profile Optimisation' },
  { value: 'Mock Technical Interview', label: 'Mock Technical Interview' },
  { value: 'Mock Managerial Interview', label: 'Mock Managerial Interview' },
  { value: 'Coding Help: Data Structure and Algorithms', label: 'Coding Help: Data Structure and Algorithms' },
  { value: 'Code Review', label: 'Code Review' },
];

